// Affiche le CartonVerificationDTO renvoye par le backend (voir CLAUDE.md).
// Champs attendus : clientNom, marqueNom, logoUrl, adresseLivraison, pays,
// modeleName, numeroCommande, numeroArticle, dateCommande, qteCommandeTotale,
// etape, etapeLabel, numeroCarton, totalCartons, lignes[{taille, quantite}].
// etape/etapeLabel ne sont pas affiches : decision produit, cette info n'apporte
// rien au client externe qui verifie juste le contenu physique du carton.
function formatterDateCommande(dateCommande) {
  if (!dateCommande) {
    return '—';
  }
  const date = new Date(dateCommande);
  if (Number.isNaN(date.getTime())) {
    return dateCommande;
  }
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function CartonResult({ carton, onScannerAutre }) {
  const lignes = carton.lignes || [];

  return (
    <div className="carton-result">
      <div className="carton-result-header">
        {carton.logoUrl ? (
          <img src={carton.logoUrl} alt={carton.marqueNom || 'Marque'} className="carton-logo" />
        ) : (
          <span className="carton-marque-nom">{carton.marqueNom || 'Marque inconnue'}</span>
        )}
      </div>

      <div className="carton-box-numero">
        Carton N° {carton.numeroCarton} / {carton.totalCartons}
      </div>

      <dl className="carton-details">
        <div className="carton-detail-row">
          <dt>Client</dt>
          <dd>{carton.clientNom || '—'}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>Marque</dt>
          <dd>{carton.marqueNom || '—'}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>Adresse de livraison</dt>
          <dd>
            {carton.adresseLivraison || '—'}
            {carton.pays ? `, ${carton.pays}` : ''}
          </dd>
        </div>
        <div className="carton-detail-row">
          <dt>Modèle</dt>
          <dd>{carton.modeleName || '—'}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>N° commande</dt>
          <dd>{carton.numeroCommande || '—'}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>N° article</dt>
          <dd>{carton.numeroArticle || '—'}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>Date commande</dt>
          <dd>{formatterDateCommande(carton.dateCommande)}</dd>
        </div>
        <div className="carton-detail-row">
          <dt>Quantité totale commande</dt>
          <dd>{carton.qteCommandeTotale || '—'}</dd>
        </div>
      </dl>

      <div className="carton-lignes">
        <h3>Contenu de ce carton</h3>
        <table>
          <thead>
            <tr>
              <th>Taille</th>
              <th>Quantité</th>
            </tr>
          </thead>
          <tbody>
            {lignes.length === 0 && (
              <tr>
                <td colSpan={2}>Aucune information de taille disponible.</td>
              </tr>
            )}
            {lignes.map((ligne, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={ligne.id ?? index}>
                <td>{ligne.taille}</td>
                <td>{ligne.quantite}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button type="button" className="btn-primary" onClick={onScannerAutre}>
        Scanner un autre carton
      </button>
    </div>
  );
}

export default CartonResult;
